import { Utils } from '@common';
import { React, Styled } from '@common/3rd';
import { DeskComponentRegistry } from '@component';
import {
	CheckableWidgetState,
	CodeItem,
	CodesWidget,
	CodesWidgetProps,
	DeskTextComponents,
	DeskTextProps,
	StyledDIV
} from '@my-types';
import { DeskText } from './desk-text';

class DeskAutoComplete<
	P extends DeskTextProps & CodesWidgetProps,
	S extends CheckableWidgetState,
	C extends DeskTextComponents & { Options: StyledDIV }
> extends DeskText<P, S, C> implements CodesWidget {
	dataListId: string = `data-list-id-${Math.random()}`;
	timeoutHandle: number | null = null;

	protected initComponents(): C {
		return Object.assign({}, super.initComponents(), {
			Box: Styled.div.attrs({
				'data-widget': 'desk-auto-complete'
			})`
				display: flex;
				${props => this.renderCSS(props.theme)}
				> input {
					appearance: none;
				}
			`,
			Options: Styled.datalist.attrs({
				'data-widget': 'desk-auto-complete-options'
			})`
			`
		}) as C;
	}
	renderOptions(): JSX.Element {
		const options = Utils.toArray(this.getCodes()).map((code, index) => {
			// value={`${code.v}`}
			return <option key={index} value={code.l} />;
		});
		const { Options } = this.getComponents();
		return <Options id={this.dataListId}>{options}</Options>;
	}
	render() {
		const C = this.getComponents();
		return (
			<C.Box>
				<C.Text
					type="text"
					onChange={this.onTextChanged}
					onFocus={this.onTextFocus}
					onBlur={this.onTextBlur}
					ref={this.textRef}
					readOnly={!this.isEditable()}
					defaultValue={this.getDisplayText()}
					list={this.dataListId}
				/>
				{this.renderReminder()}
				{this.renderOptions()}
			</C.Box>
		);
	}
	protected setValueToDOM(value: any, propName?: string): this {
		if (propName == null || propName === this.getPropName()) {
			this.textRef.current.value = this.getDisplayText();
			// this.checkData();
		}
		return this;
	}
	protected getDisplayText() {
		const value = this.getValueFromModel();
		if (Utils.isEmpty(value)) {
			return '';
		} else {
			// eslint-disable-next-line
			return (Utils.toArray(this.getCodes()).find(item => item.v == value) || { l: '' }).l;
		}
	}
	isClearable(): boolean {
		return true;
	}
	getCodes(): CodeItem[] {
		return Utils.toArray(this.props.codes);
	}
	protected onTextChanged = (): void => {
		const text = this.textRef.current.value;
		const oldValue = this.getValueFromModel();

		if (this.timeoutHandle) {
			clearTimeout(this.timeoutHandle);
			this.timeoutHandle = null;
		}
		this.timeoutHandle = window.setTimeout(() => {
			const value = (Utils.toArray(this.getCodes()).find(item => item.l === text) || { v: null }).v;
			// eslint-disable-next-line
			if (value == oldValue) {
				// 没有变化, 什么都不做
				return;
			}

			this.setValueToModel(value).checkData();
		}, 300);
	};
}

DeskComponentRegistry.register({
	ac: DeskAutoComplete
});

export { DeskAutoComplete };
